/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components {
    "use strict";

    import IComponentOptions = angular.IComponentOptions;
    import IScopeService = angular.IScope;
    import IModalService = Meevo.Components.Modal.IModalService;

    export class SuggestionsIndicator implements IComponentOptions {
        templateUrl = "app/components/suggestions/suggestionsIndicator.component.html";
        bindings: any = {

        }
        controller = class SuggestionsIndicatorController {
            public suggestions: Meevo.Model.ScanOpeningContainer[] = null;
            public suggestionsCount: number = 0;

            static $inject = ['$scope', 'meevo.components.modal.ModalService'];
            constructor(private $scope: IScopeService, private modalService: IModalService) { }

            $onInit(): void {
                this.$scope.$root["MeevoConvoSuggestionsShowing"] = false;
                this.$scope.$on(Meevo.Components.Common.Messages.APPOINTMENT_SUGGESTIONS_CHANGED, (event, args) => {
                    this.onSuggestionsChanged(args);
                });
                this.$scope.$on(Meevo.Components.Common.Messages.SUGGESTIONS_CLIENT_ADDEDIT_CALLBACK, (event, args) => {
                    if (!this.$scope.$root["MeevoConvoSuggestionsShowing"]) {
                        this.openSuggestions();
                    }
                });
            }

            public openSuggestions(): void {
                const options: Meevo.Components.Modal.IModalOptions = {
                    template: `<suggestions-results></suggestions-results>`,
                    escapeToClose: false,
                    clickOutsideToClose: false
                };
                this.$scope.$root["MeevoConvoSuggestionsShowing"] = true;
                this.modalService.showCustom(options)
                    .finally(() => {
                        this.$scope.$root["MeevoConvoSuggestionsShowing"] = false;
                    });
            }

            private onSuggestionsChanged(suggestions: Meevo.Model.ScanOpeningContainer[]) {
                this.suggestions = suggestions;
                this.suggestionsCount = this.suggestions ? this.suggestions.length : 0;
            }
        }
    }

    angular.module("meevo.components.common")
        .component("suggestionsIndicator", new SuggestionsIndicator());
}
